import React, { useMemo } from "react";
import { Outlet, useLocation } from "react-router-dom";
import SlidingTabBar from "../../Components/SlidingTabBar";
import EducationCoursePageHeader from "./EducationCoursePageHeader";
import { resolveActiveEducationCourse } from "./resolveActiveEducationCourse";
import type { Course } from "../Menu/Menu.types";

import styles from "./EducationCourseLayout.module.css";

type EducationCourseLayoutProps = {
  courses: Course[];
  selectedCourse: Course | null;
  userData: UserData | null;
  certificateRefreshKey: number;
  onTabChange: (item: TabItem) => void;
};

function EducationCourseLayout({
  courses,
  selectedCourse,
  userData,
  certificateRefreshKey,
  onTabChange,
}: EducationCourseLayoutProps) {
  const { pathname } = useLocation();

  const course = useMemo(
    () => resolveActiveEducationCourse(courses, selectedCourse, pathname),
    [courses, selectedCourse, pathname],
  );

  return (
    <>
      {course ? (
        <div className={styles.shell}>
          <EducationCoursePageHeader course={course} userData={userData} />
          <div className={styles.courseTabs}>
            <SlidingTabBar
              variant="belowHeader"
              onTabChange={onTabChange}
              courseId={course.ID}
              certificateRefreshKey={certificateRefreshKey}
            />
          </div>
        </div>
      ) : null}
      <Outlet />
    </>
  );
}

export default EducationCourseLayout;
